import type { ComputedRef } from 'vue';
import type { MonospaceSpace } from '#layers/data-model/public';
import { computed } from 'vue';
import { compareSortable } from '#layers/base/public';
import { useWorkspaceEntityStore } from '#layers/runtime/public';

export function useSpaces(): ComputedRef<MonospaceSpace[]> {
	const store = useWorkspaceEntityStore();

	const { data: spaces } = store.MonospaceSpace.query((q) => q.many());

	return computed(() => spaces.value.toSorted(compareSortable));
}
